import ListControlRepos from './ListControlRepos';

export default ListControlRepos;
